module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAdCAYAAAAgqdWEAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEaSURBVHgB7ZbhDYJADIUfxgEcgRHYwBvBDcQN3EA2kA1gA0dQJ9ANTjfACWqN/DCG9uyJiRq+BPhxeS+PFtImROQAzGFjnyRJLR2y54Qfa9hobsKc7FSaK5+nZMeP8EUMYSSGMBJDGIkhjMRfhDmjf05jvu34WnQcOsgDtIFOI3hqA/QCCR5chTLUHCK46RTPQmvTVDk7Io7M7BlYAQ6IhLVbxTeVKuNgfYNwkFTxPfKydpKEnvr/XmrFs5RE2ubnEQGFN79UEnlFlCMC0r+VShLVH6jKiiKqEhLlMMKaLOBZdYlmZlE4SKjlXqpKaRaFwyxJx8WIM0RC9zb5Ds/iFfFzaZd4k9bz8ccoLeJJ27YCPUL3wbvBr3AFlUhCVlYkBpAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/quote1.png
// module id = y9LE
// module chunks = 1